import * as prismic from "@prismicio/client";

// Define your Prismic repository name
const repositoryName = "iceiac";

// Initialize the Prismic client
export const client = prismic.createClient(repositoryName, {
  accessToken:
    "MC5aNGZ2LVJJQUFDd0FhaHJX.77-9du-_vVcN77-9fO-_ve-_vWzvv71z77-977-977-9UO-_ve-_ve-_ve-_vVkIEDjvv71g77-9fzbvv718IA", // Optional if the repository is private
});
